import { isEqual } from "lodash";

export const shallowLeftDiff = <T extends object>(
  oldValues: T,
  newValues: T
) => {
  // NOTE: this is only a "shallow" comparison, because the API should
  //   ... not support "deep patching" or "nested serializers"
  return Object.entries(newValues).reduce((diff, [key, value]) => {
    if (!isEqual(oldValues[key as keyof typeof newValues], value)) {
      return {
        ...diff,
        [key]: value,
      };
    }
    return diff;
  }, {});
};

export const hasOnlySpecificStrings = (
  arr: string[] | undefined,
  str1: string,
  str2: string
): boolean => {
  if (!arr) return false;

  return arr.length === 2 && arr.includes(str1) && arr.includes(str2);
};
